import React            from 'react';
import ReactDom         from 'react-dom';
import Moment           from 'moment';

import Const            from 'fw_const';
import Utils            from 'utils';

import SheetHeader    from '@project/contents/workflow/sheet/sheet-header';

// import ReactDataSheet from 'react-datasheet'; // TODO: package not available
// import { ContextMenu, MenuItem, ContextMenuTrigger } from 'react-contextmenu'; // TODO: package not available
// -------------------------------------------------------

class Workflow extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    let data = this.props.data;
    
    this.state = {
      sheet      : data.sheet,
      select_row : null,
    }
  }
  // -------------------------------------------------------
  
  selectRow(row) {
    this.setState({ select_row: row });
  }
  // -------------------------------------------------------
  
  updateSheet(sheet) {
    this.setState({ sheet: sheet });
  }
  // -------------------------------------------------------
  
  onCellsChanged(cells) {
    Utils.request.bind(this)('/api/project/sheet/update_column', { project_id: this.props.data.project.id, cells: cells },
      function(res){
        this.updateSheet.bind(this)(res.body.sheet);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  clickContextMenu(e, data) {
    Utils.request.bind(this)('/api/project/sheet/action_context_menu', { project_id: this.props.data.project.id, action: data.menu, item_no: data.no },
      function(res){
        this.updateSheet.bind(this)(res.body.sheet);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let sheet = this.state.sheet;
    
    // ボディ部分作成
    let body = [];
    sheet.body.map((rows, idx) => {
      let ary = [];
      rows.map((d, key) => {
        let obj = Object.assign({}, d);
        if( key == this.state.select_row ) obj.className += ' select-row';
        if( (idx + 1) == data.sheet.body.length ) obj.className += ' last-col';
        ary.push(obj);
      });
      body.push(ary);
    });
    
    let menus = [
      { id: 'left_plus',  name: '左に一列挿入' },
      { id: 'right_plus', name: '右に一列挿入' },
      { id: 'delete',     name: '列を削除' },
    ];
    
    return (
      <div className="sheet-contents">
        <div className="sheet-container">
          
          {/* TODO: ReactDataSheet not available - replaced with plain table */}
          <table className="my-awesome-extra-class">
            <SheetHeader data={data} sheet={sheet} select_row={this.state.select_row} updateSheet={this.updateSheet.bind(this)} />
            <tbody>
              { body.map((rows, ridx) => (
                <tr key={ridx}>
                  { rows.map((cell, cidx) => (
                    <td key={cidx} className={cell.className || ''}>{cell.value}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          {/* TODO: ContextMenu not available - context menu removed */}
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Workflow;